import update from 'react-addons-update';

import { ADD_CAROUSEL_DATA } from '../types/carousel';

export const carouselReducer = (state = [], action) => {
  switch (action.type) {
    // case CAROUSEL_ORIGINAL_INDEX:
    //     return addCarouselOriginalIndex(state, action);
    case ADD_CAROUSEL_DATA:
      return addCarouselData(state, action);
    default:
      return state;
  }
};

function addCarouselData(state, action) {
  const { carousel_index, originalIndexCard, data, keyName } = action.payload;
  const buttonKey = ['carousel_card_' + originalIndexCard];
  if (buttonKey in state[0]) {
    if (state[0][buttonKey].length == carousel_index) {
      return update(state, {
        0: { [buttonKey]: { $push: [{ [keyName]: data }] } },
      });
    }
    return update(state, {
      0: {
        [buttonKey]: { [carousel_index]: { $merge: { [keyName]: data } } },
      },
    });
  }
  return update(state, {
    0: { $merge: { [buttonKey]: [{ [keyName]: data }] } },
  });
}
